import { reactLocalStorage } from 'reactjs-localstorage';
import Const from '../util/Constants';

class Headers {
  constructor(method, body) {
    const Sales = 1;
    const auth = reactLocalStorage.get(Const.Token);
    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    this.method = method;
    this.headers = {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'client': 'WebClient',
      'user-id': user ? user.user_id : 0,
      'auth': auth,
      'api_type': Sales
    };
    if (body) {
      this.body = JSON.stringify(body);
    }
  }
}
export default Headers;